import _ from "lodash";
/**
 * Gets the laravel dot notation errors as object.
 *
 */
export const parseLaravelErrors = function (errors, join = true, glue = " ") {
  let obj = {};
  _.forEach(errors, function (value, key) {
    _.set(obj, key, value);
  });
  if (!join) return obj;

  const joinedErrors = _.cloneDeep(obj);
  for (let [key, value] of Object.entries(joinedErrors)) {
    joinedErrors[key] = value.join(glue);
  }
  return joinedErrors;
};
